import React, { useState } from "react";

const SipCalculator = () => {
  const [monthlyInvestment, setMonthlyInvestment] = useState(5000);
  const [investmentPeriod, setInvestmentPeriod] = useState(15); // In years
  const [expectedReturn, setExpectedReturn] = useState(9.5); // In percentage
  const [totalInvestment, setTotalInvestment] = useState(0);
  const [futureValue, setFutureValue] = useState(0);

  const handleMonthlyInvestmentChange = (amount, type) => {
    if (monthlyInvestment === 0 && type == "minus") {
      setMonthlyInvestment(0);
    } else {
      setMonthlyInvestment(monthlyInvestment + amount);
    }
  };

  const handleExpectedReturnChange = (amount) => {
    let newValue = expectedReturn + amount;
    if (newValue >= 0 && newValue <= 100) {
      setExpectedReturn(newValue);
    }
  };

  const handleInvestmentPeriodChange = (e) => {
    setInvestmentPeriod(parseInt(e.target.value));
  };

  const calculateValues = () => {
    const months = investmentPeriod * 12;
    const totalInvested = monthlyInvestment * months;
    setTotalInvestment(totalInvested);

    const monthlyReturnRate = expectedReturn / 12 / 100;
    const futureValue =
      monthlyInvestment *
      ((Math.pow(1 + monthlyReturnRate, months) - 1) / monthlyReturnRate) *
      (1 + monthlyReturnRate);
    setFutureValue(Math.round(futureValue));
  };

  React.useEffect(() => {
    calculateValues();
  }, [monthlyInvestment, investmentPeriod, expectedReturn]);

  return (
    <>
      <h1 className="project-heading">
        <strong className="purple">S.I.P. </strong>
        <b />
        Your smart way to create wealth systematically
      </h1>
      <h5>
        Boost your investment value and reach your goals faster by systematic
        investments periodically
      </h5>
      <div className="sip-calculator">
        <div className="input-container">
          <div className="input-box">
            <button
              onClick={() => handleMonthlyInvestmentChange(-500, "minus")}
            >
              -
            </button>
            <div className="col-val">
              <span>Monthly Investment</span>
              <span>{monthlyInvestment}</span>
            </div>

            <button onClick={() => handleMonthlyInvestmentChange(500, "plus")}>
              +
            </button>
          </div>

          <div className="input-box">
            <div className="col-val">
              <label>Investment Period (Years)</label>
              <select
                value={investmentPeriod}
                onChange={handleInvestmentPeriodChange}
              >
                {Array.from({ length: 35 }, (_, i) => i + 1).map((year) => (
                  <option key={year} value={year}>
                    {year} years
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="input-box">
            <button onClick={() => handleExpectedReturnChange(-0.5)}>-</button>
            <div className="col-val">
              <span>Expected Return (%)</span>
              <span>{expectedReturn}</span>
            </div>
            <button onClick={() => handleExpectedReturnChange(0.5)}>+</button>
          </div>
        </div>

        <div className="output-container">
          <div className="col-val">
            <span>Total Investment</span>
            <span>{totalInvestment}</span>
          </div>

          <div className="col-val">
            <span>Future Value</span>
            <span>{futureValue}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default SipCalculator;
